import { FadeLoader } from 'react-spinners';

const LoadingSpinner = ({ height }) => {
    return (
        <div className="loading-spinner" style={{ height }}>
            <FadeLoader color="#ef61a7" />
        </div>
    );
};

export default LoadingSpinner;
